import { render, staticRenderFns } from "./renewal.vue?vue&type=template&id=1933ffe9&"
import script from "./renewal.vue?vue&type=script&lang=js&"
export * from "./renewal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports